import { useCallback, useEffect, useState } from 'react';
import { CommercialSalesGoalService } from '../services/CommercialSalesGoalService';
import type {
  CommercialGoalsDashboard,
  CommercialGoalsQuery,
} from '../utils/commercialGoalsDashboard';

export function useCommercialGoalsDashboard(query: CommercialGoalsQuery | null) {
  const [snapshot, setSnapshot] = useState<CommercialGoalsDashboard | null>(null);
  const [loading, setLoading] = useState(Boolean(query));
  const [error, setError] = useState<string | null>(null);
  const [reloadKey, setReloadKey] = useState(0);

  const refetch = useCallback(() => {
    setReloadKey((current) => current + 1);
  }, []);

  const dateStart = query?.dateStart ?? '';
  const dateEnd = query?.dateEnd ?? '';
  const goalMonth = query?.goalMonth ?? '';

  useEffect(() => {
    if (!dateStart || !dateEnd || !goalMonth) {
      setSnapshot(null);
      setError(null);
      setLoading(false);
      return;
    }

    let ignore = false;
    setSnapshot(null);
    setLoading(true);
    setError(null);

    CommercialSalesGoalService.getDashboard(dateStart, dateEnd, goalMonth)
      .then((next) => {
        if (!ignore) {
          setSnapshot(next);
        }
      })
      .catch((caught: unknown) => {
        if (!ignore) {
          setSnapshot(null);
          setError(caught instanceof Error ? caught.message : 'Não foi possível carregar o dashboard comercial.');
        }
      })
      .finally(() => {
        if (!ignore) {
          setLoading(false);
        }
      });

    return () => {
      ignore = true;
    };
  }, [dateStart, dateEnd, goalMonth, reloadKey]);

  return { snapshot, loading, error, refetch };
}
